<template>
  <fts-design-modal
    desc="subscription configuration"
    class="fts-subscription-design-modal"
    ref="ftsDesignModal"
  >
    <!-- title -->
    <div slot="title" class="design-modal-header-title">
      Subscription <span v-if="item && item.title">for {{item.title}}</span>
    </div>
    <!-- body -->
    <template #body>
      <div class="subscription-wrapper" v-for="x in formData" :key="x.id">
        <!-- info -->
        <div class="subscription-info">
          <div class="subscription-brand">
            <img :src="getBrandLogo(x.source)">
          </div>
          <div class="subscription-name">{{x.name}}</div>
          <fts-toggle-switch
            mat-class
            :size="12"
            v-model="x.active"
          />
          <fts-btn text icon @click="removeSubscription(x.id)">
            <font-awesome-icon :icon="['far', 'trash-alt']" />
          </fts-btn>
        </div>
        <!-- audit -->
        <div class="subscription-audit">
          <div class="subscription-audit-by">by</div>
          <fts-profile :user-name="x.audit.updatedBy" />
          <div class="subscription-audit-date">
            {{moment(x.audit.updatedDate).format('lll')}}
          </div>
        </div>
      </div>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <!-- cancel -->
      <fts-btn text @click="beforeClose">Cancel</fts-btn>
      <!-- save -->
      <fts-btn outline color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import moment from "moment";
import changesets from "diff-json";

import FTSDesignModal from "./FTSDesignModal";
import FTSBtn from "../elements/FTSBtn";
import FTSToggleSwitch from "../elements/FTSToggleSwitch";
import FTSProfile from "../elements/FTSProfile";

/* assets */
import zapierLogo from "../../assets/images/brand/zapier-logo.png";
import integromatLogo from "../../assets/images/brand/integromat-logo.png";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
    "fts-toggle-switch": FTSToggleSwitch,
    "fts-profile": FTSProfile,
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
    item: null,
  }),
  methods: {
    moment,
    async show(formData, item) {
      this.item = {...item};
      this.formData  = _.cloneDeep(formData, item);
      this.originalData = _.cloneDeep(this.formData);

      return new Promise(resolve => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    },
                  },
                ],
              });
            } else {
              this.$modal.hide("dialog");
              this.reset();
            }
          }
        });
      });
    },
    done() {
      this.resolve && this.resolve(this.formData);
      this.reset();
    },
    beforeClose() {
      this.$refs.ftsDesignModal.beforeClose();
    },
    reset() {
      this.$refs.ftsDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    removeSubscription(id) {
      const ind = this.formData.findIndex(x => x.id === id);
      if (ind !== -1) this.formData.splice(ind, 1);
    },
    getBrandLogo(item) {
      switch(item) {
        case 'zapier':
          return zapierLogo;
        case 'integromat':
          return integromatLogo;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

.fts-subscription-design-modal {
  .subscription-wrapper {
    margin-bottom: 1rem;
    padding: 1rem;
    border: 1px solid var(--fts-gray-200);
    border-radius: .375rem;
    .subscription-info {
      display: flex;
      align-items: center;
      .subscription-brand {
        @include flex-center-middle;
        margin-right: .75rem;
        padding: .275rem;
        border: 1px solid var(--fts-gray-200);
        border-radius: .25rem;
        > img {
          height: 1.25rem;
          width: 1.25rem;
          object-fit: contain;
        }
      }
      .subscription-name {
        flex: 1;
        margin-right: .75rem;
        font-size: 1.25rem;
        line-height: 1.5;
      }
    }
    .subscription-audit {
      display: flex;
      align-items: center;
      margin-top: .575rem;
      font-size: .75rem;
      .subscription-audit-by {
        margin-right: .375rem;
        color: var(--fts-gray-400);
      }
      .subscription-audit-date {
        margin-left: .75rem;
        color: var(--fts-gray-400);
        white-space: nowrap;
      }
    }
  }
}
</style>